export const PLAID_UI_EVENTS = {
  SELECT_KYC_PLAID_VERIFICATION_FORM_EXIT:
    'select_kyc_plaid_verification_form_exit',
  SELECT_KYC_PLAID_VERIFICATION_FORM_EXIT_WITH_ERROR:
    'select_kyc_plaid_verification_form_exit_with_error',
  VIEW_KYC_PLAID_GO_TO_VERIFICATION_FORM:
    'view_kyc_plaid_go_to_verification_form',
  SELECT_KYC_PLAID_VERIFICATION_FORM: 'select_kyc_plaid_verification_form',
  SELECT_KYC_WHAT_IS_PLAID: 'select_kyc_what_is_plaid',
  VIEW_KYC_MODAL_VERIFY_WITH_PLAID: 'view_kyc_modal_verify_with_plaid',
  VIEW_KYC_MODAL_VERIFY_WITH_PLAID_ERROR:
    'view_kyc_modal_verify_with_plaid_error',
  PLAID_ON_LOAD: 'plaid_on_load',
  PLAID_ON_EVENT: 'plaid_on_event',
  PLAID_ON_EXIT: 'plaid_on_exit',
  PLAID_ON_SUCCESS: 'plaid_on_success',
} as const;
